<template>
    <v-container fluid>
        <v-snackbar
            :color="notifyColor"
            :timeout="5000"
            top
            v-model="notifyShow"
        >
            {{ notifyMessage }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    @click="notifyShow = false"
                    class="text-none"
                    icon
                    v-bind="attrs"
                >
                    <v-icon>mdi-close</v-icon>
                </v-btn>
            </template>
        </v-snackbar>
        <v-row align="center" no-gutters>
            <v-col cols="12" justify="center" lg="4" sm="6">
                <v-subheader>
                    <h2>Claims Non Validated ({{ totalMatches }})</h2>
                </v-subheader>
            </v-col>
            <v-col cols="12" lg="4" sm="6">
                <v-text-field
                    @click:clear="setSearch('')"
                    @input="setSearch"
                    clearable
                    label="Search"
                    prepend-icon="mdi-magnify"
                    single-line
                />
            </v-col>
            <v-col class="text-right" cols="12" lg="4" sm="6">
                <v-btn
                    @click="showFilters = !showFilters"
                    color="secondary darken-1"
                    icon
                >
                    <v-icon>mdi-tune</v-icon>
                </v-btn>
            </v-col>
        </v-row>
        <v-container class="pb-10">
            <v-row justify="center" v-if="claimsWithInfo === null">
                <v-col :key="i" cols="12" v-for="i in 6">
                    <v-skeleton-loader
                        elevation="4"
                        type="card"
                    ></v-skeleton-loader>
                </v-col>
            </v-row>
            <v-row justify="center" v-else>
                <v-col
                    :key="index"
                    cols="12"
                    v-for="(claimWithInfo, index) in claimsWithInfo"
                >
                    <v-card
                        class="incident-card fill-height"
                        elevation="4"
                        style="overflow: hidden"
                        
                    >
                    <v-card
                        flat
                        @click="loadClaimForm(claimWithInfo.entity)"
                    >
                        <v-card-subtitle>
                            Provider:
                            {{
                                getProviderName(claimWithInfo.entity.providerId)
                            }}
                            <br />
                            Incident: #{{ claimWithInfo.entity.incidentId }}
                            <br />
                            <span
                                :key="pi"
                                v-for="(
                                    patientName, pi
                                ) in getPatientsFromAccounts(
                                    claimWithInfo.entity.accounts
                                )"
                            >
                                {{ patientName }}
                                <br />
                            </span>
                            Number of Accounts:
                            {{ claimWithInfo.info.accountsCount }}
                            <br />
                            Face Value: R{{
                                claimWithInfo.info.faceValue.toFixed(2)
                            }}
                            <br />
                            Purchase Value: R{{
                                claimWithInfo.info.purchaseValue.toFixed(2)
                            }}
                        </v-card-subtitle>
                    </v-card>

                        <v-card-subtitle class="py-0 my-0"
                            ><strong>Accounts</strong></v-card-subtitle
                        >
                        <v-expansion-panels
                            :key="indexA"
                            v-for="(account, indexA) in claimWithInfo.entity
                                .accounts"
                        >
                            <v-expansion-panel
                                @click.stop="() => ({})"
                                class="patient-panel"
                            >
                                <v-expansion-panel-header>
                                    <v-row justify="start">
                                        <v-col cols="12">
                                            <div style="display: inline-block">
                                                #{{ account.id }}
                                            </div>
                                        <v-template
                                        v-show="account.hasPrefundFunding"
                                        >
                                            <v-chip
                                                class="ma-1"
                                                color="secondary lighten-1"
                                                dark
                                                small
                                            >
                                                Prefund GRV Number:
                                                {{ account.grvNumberPrefund }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary lighten-1"
                                                dark
                                                small
                                            >
                                                Prefund Face Value:
                                                {{
                                                account.faceValuePrefund.toFixed(2)
                                                }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary lighten-1"
                                                dark
                                                small
                                            >
                                                Prefund Purchase Value:
                                                {{
                                                    ((account.faceValuePrefund / 100) * (100 - account.providerPrefundFeePercentage)).toFixed(2)
                                                }}
                                            </v-chip>
                                        </v-template>
                                        <v-template
                                        v-show="account.hasAdminFunding"
                                        >
                                            <v-chip
                                                class="ma-1"
                                                color="secondary darken-1"
                                                dark
                                                small
                                            >
                                                Administered GRV Number:
                                                {{ account.grvNumberAdmin }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary darken-1"
                                                dark
                                                small
                                            >
                                                Administered Face Value:
                                                {{
                                                account.faceValueAdmin.toFixed(2)
                                                }}
                                            </v-chip>
                                            <v-chip
                                                class="ma-1"
                                                color="secondary darken-1"
                                                dark
                                                small
                                            >
                                                Administered Purchase Value:
                                                {{
                                                    ((account.faceValueAdmin / 100) * (100 - account.providerAdminFeePercentage)).toFixed(2)
                                                }}
                                            </v-chip>
                                        </v-template>
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-header>
                                <v-expansion-panel-content>
                                    <v-row justify="space-around">
                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Created
                                                <br />
                                                <h3>
                                                    {{
                                                        dateToString(
                                                            account.createdAt
                                                        )
                                                    }}
                                                </h3>
                                            </v-card>
                                        </v-col>

                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Processed
                                                <br />
                                                <h3>
                                                    <span
                                                        v-if="
                                                            account.processedAt
                                                        "
                                                        >{{
                                                            dateToString(
                                                                account.processedAt
                                                            )
                                                        }}</span
                                                    >
                                                    <v-icon color="error" v-else
                                                        >mdi-close</v-icon
                                                    >
                                                </h3>
                                            </v-card>
                                        </v-col>

                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Accepted
                                                <br />
                                                <h3>
                                                    <span
                                                        v-if="
                                                            account.acceptedAt
                                                        "
                                                        >{{
                                                            dateToString(
                                                                account.acceptedAt
                                                            )
                                                        }}</span
                                                    >
                                                    <v-icon color="error" v-else
                                                        >mdi-close</v-icon
                                                    >
                                                </h3>
                                            </v-card>
                                        </v-col>

                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Final Acc.
                                                <br />
                                                <h3>
                                                    <v-icon
                                                        color="success"
                                                        v-if="
                                                            account.isFinalAccount
                                                        "
                                                        >mdi-check</v-icon
                                                    >
                                                    <v-icon color="error" v-else
                                                        >mdi-close</v-icon
                                                    >
                                                </h3>
                                            </v-card>
                                        </v-col>

                                        <v-col
                                            class="text-center"
                                            cols="6"
                                            md="2"
                                        >
                                            <v-card
                                                class="pa-1 ma-1 fill-height"
                                            >
                                                Paid
                                                <br />
                                                <h3>
                                                    <v-icon
                                                        color="success"
                                                        v-if="account.isPaid"
                                                        >mdi-check</v-icon
                                                    >
                                                    <v-icon color="error" v-else
                                                        >mdi-close</v-icon
                                                    >
                                                </h3>
                                            </v-card>
                                        </v-col>
                                        <v-col cols="12"
                                            >{{ account.patient.identity.name }}
                                            {{
                                                account.patient.identity.surname
                                            }}
                                            <br />{{
                                                getIdentityTypeName(
                                                    account.patient.identity
                                                        .identityTypeId
                                                )
                                            }}:
                                            {{
                                                account.patient.identity
                                                    .identificationNumber
                                            }}
                                        </v-col>
                                    </v-row>
                                </v-expansion-panel-content>
                            </v-expansion-panel>
                        </v-expansion-panels>
                    </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!--EDIT/NEW FORM SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            fullscreen
            hide-overlay
            transition="dialog-bottom-transition"
            v-model="claimFormVisible"
        >
            <v-sheet class="base-background" min-height="100%">
                <v-toolbar color="secondary darken-1" dark>
                    <v-btn @click="closeClaimForm" dark icon>
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    <v-toolbar-title>Claim Details</v-toolbar-title>
                    <v-spacer></v-spacer>
                </v-toolbar>
                <v-container>
                    <v-row align="center" justify="center" v-if="true">
                        <ClaimForm
                            :claim-in="claimFormClaim"
                            :key="claimFormKey"
                            @close="closeClaimForm"
                            @notify="notify"
                        />
                    </v-row>
                </v-container>
            </v-sheet>
        </v-dialog>

        <!--FILTER SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-dialog
            transition="scroll-x-reverse-transition"
            v-model="showFilters"
            width="350px"
        >
            <v-card>
                <v-card-title>Claim Filtering</v-card-title>
                <v-card-text>
                    <v-select
                        :items="providers"
                        @change="
                            () => {
                                pageNo = 1;
                                paginationDebounce(filterDebounceTime);
                            }
                        "
                        class="my-0"
                        clearable
                        item-text="value"
                        item-value="key"
                        label="Provider"
                        v-model="filterProviderId"
                    ></v-select>
                    <v-divider class="mt-3 mb-8"></v-divider>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        @click="resetFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                        >Reset</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn
                        @click="showFilters = !showFilters"
                        class="text-none"
                        color="secondary darken-1"
                        text
                        >Close</v-btn
                    >
                </v-card-actions>
            </v-card>
        </v-dialog>

        <!--PAGINATION SECTION-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-*-->
        <v-pagination
            :length="pagesCount"
            @input="paginationDebounce(500)"
            class="pagination-bar base-background"
            total-visible="7"
            v-model="pageNo"
            v-show="pagesCount > 1"
        ></v-pagination>
    </v-container>
</template>

<script>
import ClaimForm from "../components/forms/ClaimForm";
import dateToString from "../helpers/dateToString";
import Claim from "../models/Claim.model";
import uuid4 from "../helpers/uuid4";

export default {
    name: "ClaimsNonValidated",
    props: ["providerId"],
    data: function () {
        return {
            //main data
            claimsWithInfo: null,
            fundingTypes: [],
            //pagination
            pageNo: 1,
            pageSize: 6,
            pagesCount: 0,
            searchString: "",
            orderBy: "",
            sortOrder: 0,
            paginationTimeout: null,
            requestId: uuid4(),
            totalMatches: null,

            //form data
            claimFormVisible: false,
            claimFormKey: 0,
            claimFormClaim: new Claim(),

            providers: [],

            //filters
            showFilters: false,
            filterDebounceTime: 500,
            filterProviderId: this.providerId > 0 ? this.providerId : null,
            //
            notifyShow: null,
            notifyMessage: null,
            notifyColor: null,

        };
    },
    mounted: async function () {
        this.providers = await this.$store.dispatch("providers/getlist");
        this.fundingTypes = await this.$store.dispatch(
            "accounts/getFundingTypes"
        );
        this.identityTypes = await this.$store.dispatch("identities/getTypes");
        this.getClaims();
    },
    components: {
        ClaimForm,
        //
    },
    methods: {
        notify(message, color) {
            this.notifyShow = true;
            this.notifyMessage = message;
            this.notifyColor = color;
        },
        async getClaims() {
            this.claimsWithInfo = null;
            var requestId = (this.requestId = uuid4());

            var claimsResponse = await this.$store.dispatch(
                "claims/getNonValidated",
                {
                    id: null,
                    urlParameters: {
                        pageNo: this.pageNo,
                        pageSize: this.pageSize,
                        searchString: this.searchString,
                        orderBy: this.orderBy,
                        sortOrder: this.sortOrder,
                        providerId: this.filterProviderId
                            ? this.filterProviderId
                            : null,
                    },
                    requestId: requestId,
                }
            );

            if (this.requestId == claimsResponse.requestId) {
                //claimsResponse.data.page.forEach(x =>this.claimApplyDisciplineName(x.entity));
                this.claimsWithInfo = claimsResponse.data.page;
                this.totalMatches = claimsResponse.data.total;
                this.pagesCount = Math.ceil(
                    claimsResponse.data.total / this.pageSize
                );
            }
        },
        paginationDebounce(debounceTime) {
            if (this.claimsWithInfo !== null) this.claimsWithInfo = null;
            clearTimeout(this.paginationTimeout);
            this.paginationTimeout = setTimeout(this.getClaims, debounceTime);
        },
        setSearch(value) {
            this.searchString = value;
            this.pageNo = 1;
            this.pagesCount = 0;
            this.paginationDebounce(2000);
        },
        resetFilters() {
            this.filterProviderId = null;
            this.filterPatient = null;
            this.paginationDebounce(0);
        },
        /*
        claimApplyDisciplineName(claim) {
            claim.disciplineName = this.claimDisciplines.find(
                y => y.id == claim.disciplineId
            ).name;
        },*/
        loadClaimForm(claim) {
            this.claimFormClaim = new Claim().set(claim);
            this.claimFormClaim.id = 0;
            this.claimFormKey = this.claimFormClaim.id;
            this.claimFormVisible = true;
        },
        async closeClaimForm() {
            this.claimFormVisible = false;
            this.claimFormClaim = new Claim();
            this.claimFormKey = null;
            this.paginationDebounce(0);
        },
        getProviderName(id) {
            var i = this.providers
                ? this.providers.find((x) => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getFundingTypeName(id) {
            var i = this.fundingTypes
                ? this.fundingTypes.find((x) => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getIdentityTypeName(id) {
            var i = this.identityTypes
                ? this.identityTypes.find((x) => x.key == id)
                : null;
            return i ? i.value : "";
        },
        getPatientsFromAccounts(accounts) {
            return accounts.reduce(function (r, e) {
                if (!(e.patientId in r))
                    r[e.patientId] =
                        e.patient.identity.name +
                        " " +
                        e.patient.identity.surname;
                return r;
            }, {});
        },
        dateToString(date) {
            return dateToString(date ? new Date(date) : null);
        },
    },
};
</script>

<style lang="stylus" scoped>
.incident-card {
    /* background: linear-gradient(45deg, rgba(127,127,127,0.1), transparent,rgba(127,127,127,0.1)) */
    .center-content {
        background-color: rgba(127, 127, 127, 0.15);
    }
}

.theme--dark {
    .patient-panel {
        .v-card {
            background-color: rgba(127, 127, 127, 0.1);
        }
    }
}

.pagination-bar {
    // position: fixed;
    bottom: 0;
    margin: auto;
    left: 0;
    right: 0;
    padding-bottom: 0.1rem;
    padding-top: 0.1rem;
    /*
    border-top-left-radius: 4px;
    border-top-right-radius: 4px;
    border:1px solid rgba(127, 127, 127, 0.2)
    */
}

.theme--light {
    .base-background {
        background: #FFFFFF;
    }
}

.theme--dark {
    .base-background {
        background: #121212;
    }
}
</style>
